import React, { useState } from 'react';
import { X, Eye, EyeOff, CheckCircle } from 'lucide-react';
interface PasswordChangeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const PasswordChangeModal = ({
  isOpen,
  onClose
}: PasswordChangeModalProps) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Reset error state
    setError('');
    // Basic validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Lütfen tüm alanları doldurunuz.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Yeni şifre ve şifre tekrarı eşleşmiyor.');
      return;
    }
    if (newPassword.length < 8) {
      setError('Yeni şifre en az 8 karakter olmalıdır.');
      return;
    }
    // Simulate API call
    setTimeout(() => {
      setIsSuccess(true);
      // Reset form
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      // Close modal after success
      setTimeout(() => {
        onClose();
        setIsSuccess(false);
      }, 2000);
    }, 1000);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 flex items-center justify-center z-50" data-id="element-1433">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} data-id="element-1434"></div>
      <div className="relative bg-black/90 border border-emerald-500/30 shadow-[0_0_25px_rgba(16,185,129,0.2)] rounded-lg w-full max-w-md mx-4 overflow-hidden" data-id="element-1435">
        {isSuccess ? <div className="p-6 flex flex-col items-center" data-id="element-1436">
            <div className="w-16 h-16 rounded-full bg-emerald-500/20 flex items-center justify-center mb-4" data-id="element-1437">
              <CheckCircle className="h-8 w-8 text-emerald-500" data-id="element-1438" />
            </div>
            <h3 className="text-xl font-bold text-center mb-2" data-id="element-1439">
              Şifre Başarıyla Güncellendi
            </h3>
            <p className="text-gray-400 text-center" data-id="element-1440">
              Yeni şifreniz başarıyla kaydedildi.
            </p>
          </div> : <>
            <div className="flex justify-between items-center p-6 border-b border-gray-800" data-id="element-1441">
              <h3 className="text-lg font-bold" data-id="element-1442">Şifre Değiştir</h3>
              <button onClick={onClose} className="text-gray-400 hover:text-white" data-id="element-1443">
                <X className="h-5 w-5" data-id="element-1444" />
              </button>
            </div>
            <form onSubmit={handleSubmit} className="p-6" data-id="element-1445">
              {error && <div className="mb-4 p-3 bg-red-900/30 border border-red-500/30 text-red-400 rounded-md text-sm" data-id="element-1446">
                  {error}
                </div>}
              <div className="space-y-4" data-id="element-1447">
                <div data-id="element-1448">
                  <label className="block text-sm text-gray-400 mb-1" data-id="element-1449">
                    Mevcut Şifre
                  </label>
                  <div className="relative" data-id="element-1450">
                    <input type={showCurrentPassword ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-gray-700 focus:border-emerald-500 pr-10" placeholder="••••••••" data-id="element-1451" />
                    <button type="button" onClick={() => setShowCurrentPassword(!showCurrentPassword)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1452">
                      {showCurrentPassword ? <EyeOff className="h-4 w-4" data-id="element-1453" /> : <Eye className="h-4 w-4" data-id="element-1454" />}
                    </button>
                  </div>
                </div>
                <div data-id="element-1455">
                  <label className="block text-sm text-gray-400 mb-1" data-id="element-1456">
                    Yeni Şifre
                  </label>
                  <div className="relative" data-id="element-1457">
                    <input type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-gray-700 focus:border-emerald-500 pr-10" placeholder="••••••••" data-id="element-1458" />
                    <button type="button" onClick={() => setShowNewPassword(!showNewPassword)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1459">
                      {showNewPassword ? <EyeOff className="h-4 w-4" data-id="element-1460" /> : <Eye className="h-4 w-4" data-id="element-1461" />}
                    </button>
                  </div>
                  <p className="mt-1 text-xs text-gray-500" data-id="element-1462">
                    Şifreniz en az 8 karakter olmalıdır.
                  </p>
                </div>
                <div data-id="element-1463">
                  <label className="block text-sm text-gray-400 mb-1" data-id="element-1464">
                    Şifre Tekrarı
                  </label>
                  <div className="relative" data-id="element-1465">
                    <input type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full bg-white/5 text-white rounded-lg px-4 py-2 border border-gray-700 focus:border-emerald-500 pr-10" placeholder="••••••••" data-id="element-1466" />
                    <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-1467">
                      {showConfirmPassword ? <EyeOff className="h-4 w-4" data-id="element-1468" /> : <Eye className="h-4 w-4" data-id="element-1469" />}
                    </button>
                  </div>
                </div>
                <div className="pt-4 flex justify-end space-x-3" data-id="element-1470">
                  <button type="button" onClick={onClose} className="px-4 py-2 bg-white/5 hover:bg-white/10 rounded-lg" data-id="element-1471">
                    İptal
                  </button>
                  <button type="submit" className="px-4 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 rounded-lg" data-id="element-1472">
                    Şifreyi Güncelle
                  </button>
                </div>
              </div>
            </form>
          </>}
      </div>
    </div>;
};